import styled, { css } from '@mint-lib/styled';

import { Box } from '@myn/mui';

export const FormattingSpanWrapper = styled(Box)<{
  $scale: number;
}>`
  ${({ $scale, theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: ${8 * $scale}px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: ${$scale < 1
      ? `${12 * $scale}px ${theme.spacing(1.5)}`
      : `${theme.spacing(1.5)}`};

    & > span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      font-size: ${0.875 * $scale}rem;
      line-height: ${$scale}rem;
      color: inherit;
      cursor: default;
    }

    & > a {
      width: 100%;
      color: unset;
      text-decoration: none;
    }
  `}
`;
